import React, { useState } from "react";
import {
  Box,
  Drawer,
  ListItem,
  TextField,
  Typography,
  Stack,
  List,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PosDrawer = ({ open, onClose, categories, onCategoryClick }) => {
  const [filter, setFilter] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: isMobile ? "100vw" : 300 } }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", top: 10, right: 10, zIndex: 1 }}
      >
        <CloseIcon />
      </IconButton>

      <Box p={2} display="flex" flexDirection="column" gap={2}>
        {/* Logo and Company Name */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <img
            src="/logo.png"
            alt="Logo"
            width={40}
            height={40}
            style={{ borderRadius: 4 }}
          />
          <Typography variant="h6" fontWeight="bold">
            My Company
          </Typography>
        </Stack>

        {/* User Autocomplete */}

        {/* Category Search */}
        <TextField
          size="small"
          placeholder="Search Category"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />

        {/* Category List */}
        <List dense>
          {categories
            .filter((cat) =>
              cat?.Typ?.toLowerCase().includes(filter.toLowerCase())
            )
            .map((cat, index) => (
              <React.Fragment key={index}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      onCategoryClick(cat);
                      onClose();
                    }}
                  >
                    <ListItemText primary={cat.Typ} />
                  </ListItemButton>
                </ListItem>
                {index < categories.length - 1 && <Divider />}
              </React.Fragment>
            ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default PosDrawer;
